import { render } from "./Prayer.vue?vue&type=template&id=54f91c71&scoped=true"
import script from "./Prayer.vue?vue&type=script&lang=js"
export * from "./Prayer.vue?vue&type=script&lang=js"

import "./Prayer.vue?vue&type=style&index=0&id=54f91c71&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f91c71"]])

export default __exports__